<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="grid-container">
    <div class="grid-x grid-padding-x formfield">
      <div class="cell text-center">
        <app-advisor-image path="/bkc/bkc-einstieg.svg" [altText]="'bekocheck.start.alt_text' | translate"></app-advisor-image>
      </div>

      <div class="cell">
        <h2>{{ 'bekocheck.einstieg.selection.headline' | translate }}</h2>
        <label class="label-field">{{ 'bekocheck.nutzungstyp.label' | translate }}</label>
      </div>

      <div class="cell">
        <mat-radio-group formControlName="nutzungstyp">
          @for (nutzungstyp of nutzungstypList; track nutzungstyp) {
            <div class="cell small-6">
              <mat-radio-button [value]="nutzungstyp" color="primary" name="nutzungstyp">
                <span [innerHTML]="'bekocheck.nutzungstyp.' + nutzungstyp + '.label' | translate"></span>
              </mat-radio-button>
            </div>
          }
        </mat-radio-group>
      </div>

    </div>

    <div class="cell">
      <div class="callout lighter-gray" [innerHTML]="'bekocheck.eingabe.start.callout2' | translate"></div>
      <div class="callout second" [innerHTML]="'bekocheck.eingabe.start.callout1' | translate"></div>
      <div class="callout">
        <div class="button-wrapper">
          <a [href]="shortVersionButtonUrl" (click)="saveData()" [class.disabled]="!form.valid" class="button inline-arrow-right"
          target="_blank">{{ 'bekocheck.einstieg.submit' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</form>
